// removed by extract-text-webpack-plugin
module.exports = {"menu":"_1bwk7cpRcFAJSR1qJD4S4_","inner":"K3CjdFkehxvz7b-2ubXb2","scrollToTop":"_3kPhrnBZbjXmn3zY41TkTv","logo":"MV-RDty1NjTi0Q9Bgssh","logoFallbackText":"_23NYWn0Z7lTi2rqPOnVc-S","logoImage":"_1c--LUkaVaAZmq7yFBE5lH","anchorsHeading":"_1FIVsQq8dgeHM0CnAlz4QL","listWrapper":"_12wd8Bzjbhsc-vT7jfuPwX","list":"_2fM1FaZSSBwvNaqVV1xuuX","header":"_14gcDYiU8UqJGFgcudTYzv","toggle":"_1_tuZanNbrtpvXwl26ZV5u","toggleText":"kmY_AwEPlkJr4EsNdOJYn","toggleCross":"_1DISTPXUCxaN0ruS-kyuYE","arrow":"Q1b8bJMTeCDO57iGc58xg","button":"_3KPHbIIbfXOfhaMa9VIMbq","active":"TZnM1_jX_8HqvmOkiAsah"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AnchorMenu/AnchorMenu.module.scss
// module id = 731
// module chunks = 0